// extracted by mini-css-extract-plugin
export default {"content":"index_content_Qz5kR","footer":"index_footer_MOD35"};